import gsap from 'gsap';
import { defineElement } from '~/utils/gw-utils';

class TickerList extends HTMLElement {
  constructor() {
    super();

    this.isRunning = false;
    this.speed = 50;
    this.wrapperClass = this.dataset.wrapperClass ?? 'ticker__items';

    this.clone();
    this.animate();
    this.onMouseEnter = this.pause.bind(this);
    this.onMouseLeave = this.play.bind(this);
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.observe();
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.observer.disconnect();
  }

  observe() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.play();
        } else {
          this.pause();
        }
      },
      {
        rootMargin: '200px 0px',
      }
    );

    this.observer.observe(this);
  }

  clone() {
    const originalNodes = Array.from(this.childNodes);
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < 3; i++) {
      const wrapper = document.createElement('div');
      wrapper.className = this.wrapperClass;
      wrapper.setAttribute('data-ticker-items', '');

      // Append clones of the original nodes
      originalNodes.forEach((node) => {
        wrapper.appendChild(node.cloneNode(true));
      });

      fragment.appendChild(wrapper);
    }

    // Clear current content and append the fragment once
    this.textContent = '';
    this.appendChild(fragment);
  }

  animate() {
    this.contentWidth = this.querySelector('[data-ticker-items]').offsetWidth;
    this.duration = this.contentWidth / this.speed;

    this.tween = gsap.to(this.querySelectorAll('[data-ticker-items]'), {
      duration: this.duration,
      xPercent: -100,
      ease: 'none',
      repeat: -1,
    });

    this.isRunning = true;
  }

  play() {
    this.tween.play();
  }

  pause() {
    this.tween.pause();
  }
}

if (!window.accessibilityMode) {
  defineElement('ticker-list', TickerList);
}
